
import { httpRequest } from "../../http";

export class CommandFetchNotebooks {
    async run(organizationId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/?organization=${organizationId}`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

   
}

